import * as React from 'react';
import { FootnoteReference } from '../footnotes/components/FootnoteReference';
import { DangerousElement } from '../DangerousElement';
const MATCHING_KEYS = [
    'powerkw',
    'powerDisplay',
    'hybrid-electrical-power',
    'max-output',
    'max-output-kw',
    'electrical-power',
];
const MATCHING_VALS = [220, 195, 210, 250];
const MATCHING_MODELS = ['q4etron', 'q4sbetron'];
const MATCHING_UNIT = 'kw';
function getFootnoteReference(power) {
    if (power === 210 || power === 250) {
        return 'max-power-q4-audi-footnote-engine';
    }
    return `nemo-fn_engine-power-boost-${power}`;
}
export const checkForEtronPowerBoostDisclaimer = ({ vehicle, techDataValue, techDataKey, }) => {
    const carline = vehicle.symbolicCarline && vehicle.symbolicCarline.code ? vehicle.symbolicCarline.code : '';
    const isRelevantCarline = MATCHING_MODELS.some((cl) => cl.toLowerCase() === carline.toLowerCase());
    const isRelevantKey = MATCHING_KEYS.some((matchedKey) => techDataKey.match(new RegExp(matchedKey, 'gmi')));
    const hasMatchedValues = MATCHING_VALS.filter((val) => String(techDataValue).match(new RegExp(`${val}\\s?${MATCHING_UNIT}`, 'gmi'))).length > 0;
    return isRelevantKey && isRelevantCarline && hasMatchedValues;
};
export const TechDataFootnoteLabel = ({ vehicle, techDataKey, techDataValue, wrappedDangerously = false, }) => {
    const hasEtronPowerBoostDisclaimer = checkForEtronPowerBoostDisclaimer({
        vehicle,
        techDataValue,
        techDataKey,
    });
    if (hasEtronPowerBoostDisclaimer === false) {
        return techDataKey === 'UpholsteryType' ? (React.createElement(DangerousElement, { html: techDataValue.toString(), as: "span", sanitize: false })) : (React.createElement(React.Fragment, null, techDataValue));
    }
    const matchedValues = MATCHING_VALS.filter((val) => String(techDataValue).match(new RegExp(`${val}\\s?${MATCHING_UNIT}`, 'gmi')));
    const powerValue = matchedValues.pop();
    const match = new RegExp(`${powerValue}\\s?${MATCHING_UNIT}`, 'gmi').exec(String(techDataValue))[0];
    const valsArr = String(techDataValue).split(match);
    return (React.createElement(React.Fragment, null,
        wrappedDangerously ? (React.createElement(DangerousElement, { html: valsArr.shift() + match, as: "span", sanitize: false })) : (valsArr.shift() + match),
        React.createElement(FootnoteReference, { refId: getFootnoteReference(powerValue) }),
        valsArr.length === 1 &&
            !!valsArr[valsArr.length - 1] &&
            (wrappedDangerously ? (React.createElement(DangerousElement, { html: valsArr.pop(), as: "span", sanitize: false })) : (valsArr.pop()))));
};
